module.exports = __webpack_public_path__ + "img/wfo_seating.2ce34840.png";